// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"ModalFooter_modalFooter__TIr_G","modalFooterFlexLayout":"ModalFooter_modalFooterFlexLayout__2ANOT"};